export const OSKLEN_ID = "3049";
export const BEAUT_ID = "13565";
export const BRINQUEDOS_ID = "13582";
